<!-- 编辑框 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" width="50%" :append-to-body="true" :before-close="handleCloseDialog">
        <el-form :model="deviceForm" size="mini">
           <el-form-item label="选择水流颜色">
                <el-select v-model="deviceForm.colorLine" placeholder="请选择颜色">
                    <el-option label="红色" value="redLine"></el-option>
                    <el-option label="棕色" value="brownLine"></el-option>
                    <el-option label="绿色" value="greenLine"></el-option>
                    <el-option label="黄色" value="yellowLine"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择水流方向">
                <el-select v-model="deviceForm.directionLine" placeholder="请选择方向">
                    <el-option label="由上往下" value="sBottom"></el-option>
                    <el-option label="由下往上" value="sTop"></el-option>
                    <el-option label="由左往右" value="sRight"></el-option>
                    <el-option label="由右往左" value="sLeft"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择水泵组">
                <el-select v-model="deviceForm.pumpGroup" placeholder="请选择" @focus="getPumpList" @change="handleChangePump">
                    <el-option
                        v-for="item in pumpList"
                        :key="item.index"
                        :label="item.title"
                        :value="item.index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-for="(domain, index) in deviceForm.condition"
                :label="'条件' + (index+1)"
                :key="domain.key"
            >
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-select v-model="domain.addr" filterable placeholder="请选择变量地址">
                            <el-option
                                v-for="item in varData"
                                :key="item.value"
                                :label="item.var_name+' : '+item.var_Initial_addr"
                                :value="item.oid">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <el-input v-model="domain.value" placeholder="值"></el-input>
                    </el-col>
                    <el-col :span="7">
                        <el-select v-model="domain.relation" placeholder="请选择判断关系">
                            <el-option label="与" value="1"></el-option>
                            <el-option label="或" value="2"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <el-button type="danger" @click.prevent="removeDomain(domain)">删除</el-button>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item>
               <el-button @click="addCondition">增加条件</el-button>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'

const Params = {
    colorLine: '',
    directionLine: '',
    pumpGroup: '',
    condition: [{
        addr: '',
        value: '',
        relation: '',
        key: Date.now()
    }],
}

export default {
    name: 'cmpLineDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        form: {
            type: Object,
            default: {}
        }
    },
    data () {
        return {
            dialogFormVisible: false,
            deviceForm: JSON.parse(JSON.stringify(Params)),

            pumpList: [],
        };
    },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData(this.form);
            }
        }
    },

    computed: {
        ...mapGetters(["machine"]),
        title() {
            return '设置水流';
        },
        varData() {
            return this.machine.var_config
        }
    },
    
    methods: {
        async handleInitData(Val) {
            if(JSON.stringify(Val) === "{}") return;
            
            if(Val.dataset.params !== undefined) {
                // 获取水泵组
                if(this.pumpList.length === 0) {
                    this.getPumpList()
                }
                // 编辑
                let params = JSON.parse(Val.dataset.params);
                let group = this.pumpList.filter(v=>{return v.index === params.pumpGroup})[0]
                await this.getPlcConfig(group.plc_id)
                this.deviceForm = params
            }else{
                // 新增
                this.deviceForm = JSON.parse(JSON.stringify(Params));
            }
            
        },
        // 获取变量列表
        async getPlcConfig(terminal_id) {
            
            if(terminal_id === '') 
            {
                let list = []
                this.$store.dispatch('setVarConfig', list);
                return
            }
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.$store.dispatch('setVarConfig', list);
                this.deviceForm.condition = [{
                    addr: '',
                    value: '1',
                    relation: '2',
                    key: Date.now()
                }];
            }
        },
        getPumpList() {
            let members = window.SVG.select('.pumb_group').members
            if(members.length === 1) {
                let dataset = JSON.parse(members[0].node.dataset.params)
                this.pumpList = dataset.pumpTab
            } 
        },
        handleChangePump(val){
            let obj = this.pumpList.filter(v=>{return v.index === val})[0]
            this.getPlcConfig(obj.plc_id)
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认关闭
        handleSave() {
            if(this.deviceForm.pumpGroup == "" || this.deviceForm.colorLine == '' || this.deviceForm.directionLine == "") {
                this.$message({
                    type: 'warning',
                    message: '请设置水流相关参数'
                });
                return
            }
            this.$emit("handleCloseDialog", {flag: true, data: this.deviceForm});
        },
        
        addCondition() {
            this.deviceForm.condition.push({
                addr: '',
                value: '1',
                relation: '2',
                key: Date.now()
            });
        },
        removeDomain(item) {
            var index = this.deviceForm.condition.indexOf(item)
            if (index !== -1) {
                this.deviceForm.condition.splice(index, 1)
            }
        },
    }
}

</script>
<style lang='less' scoped>

</style>